export default [
  {
    timeZoneName: 'Etc/GMT-14',
    timeZoneOffset: 840,
    timeZoneDescription: '(UTC+14:00) Etc/GMT-14',
    timeZoneShortDescription: 'UTC+14:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Kiritimati',
    timeZoneOffset: 840,
    timeZoneDescription: '(UTC+14:00) Pacific/Kiritimati',
    timeZoneShortDescription: 'UTC+14:00/+14',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-13',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Etc/GMT-13',
    timeZoneShortDescription: 'UTC+13:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Apia',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Pacific/Apia',
    timeZoneShortDescription: 'UTC+13:00/+13',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Enderbury',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Pacific/Enderbury',
    timeZoneShortDescription: 'UTC+13:00/+13',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Fakaofo',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Pacific/Fakaofo',
    timeZoneShortDescription: 'UTC+13:00/+13',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Kanton',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Pacific/Kanton',
    timeZoneShortDescription: 'UTC+13:00/+13',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Tongatapu',
    timeZoneOffset: 780,
    timeZoneDescription: '(UTC+13:00) Pacific/Tongatapu',
    timeZoneShortDescription: 'UTC+13:00/+13',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'NZ-CHAT',
    timeZoneOffset: 765,
    timeZoneDescription: '(UTC+12:45) NZ-CHAT',
    timeZoneShortDescription: 'UTC+12:45/+1245',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Chatham',
    timeZoneOffset: 765,
    timeZoneDescription: '(UTC+12:45) Pacific/Chatham',
    timeZoneShortDescription: 'UTC+12:45/+1245',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/McMurdo',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Antarctica/McMurdo',
    timeZoneShortDescription: 'UTC+12:00/NZST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/South_Pole',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Antarctica/South Pole',
    timeZoneShortDescription: 'UTC+12:00/NZST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Anadyr',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Asia/Anadyr',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kamchatka',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Asia/Kamchatka',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-12',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Etc/GMT-12',
    timeZoneShortDescription: 'UTC+12:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Kwajalein',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Kwajalein',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'NZ',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) NZ',
    timeZoneShortDescription: 'UTC+12:00/NZST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Auckland',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Auckland',
    timeZoneShortDescription: 'UTC+12:00/NZST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Fiji',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Fiji',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Funafuti',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Funafuti',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Kwajalein',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Kwajalein',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Majuro',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Majuro',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Nauru',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Nauru',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Tarawa',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Tarawa',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Wake',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Wake',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Wallis',
    timeZoneOffset: 720,
    timeZoneDescription: '(UTC+12:00) Pacific/Wallis',
    timeZoneShortDescription: 'UTC+12:00/+12',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Magadan',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Asia/Magadan',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Sakhalin',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Asia/Sakhalin',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Srednekolymsk',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Asia/Srednekolymsk',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-11',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Etc/GMT-11',
    timeZoneShortDescription: 'UTC+11:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Bougainville',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Bougainville',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Efate',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Efate',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Guadalcanal',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Guadalcanal',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Kosrae',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Kosrae',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Norfolk',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Norfolk',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Noumea',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Noumea',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Pohnpei',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Pohnpei',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Ponape',
    timeZoneOffset: 660,
    timeZoneDescription: '(UTC+11:00) Pacific/Ponape',
    timeZoneShortDescription: 'UTC+11:00/+11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/LHI',
    timeZoneOffset: 630,
    timeZoneDescription: '(UTC+10:30) Australia/LHI',
    timeZoneShortDescription: 'UTC+10:30/+1030',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Lord_Howe',
    timeZoneOffset: 630,
    timeZoneDescription: '(UTC+10:30) Australia/Lord Howe',
    timeZoneShortDescription: 'UTC+10:30/+1030',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/DumontDUrville',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Antarctica/DumontDUrville',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Macquarie',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Antarctica/Macquarie',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ust-Nera',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Asia/Ust-Nera',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Vladivostok',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Asia/Vladivostok',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/ACT',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/ACT',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Brisbane',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Brisbane',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Canberra',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Canberra',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Currie',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Currie',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Hobart',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Hobart',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Lindeman',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Lindeman',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Melbourne',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Melbourne',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/NSW',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/NSW',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Queensland',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Queensland',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Sydney',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Sydney',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Tasmania',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Tasmania',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Victoria',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Australia/Victoria',
    timeZoneShortDescription: 'UTC+10:00/AEST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-10',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Etc/GMT-10',
    timeZoneShortDescription: 'UTC+10:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Chuuk',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Chuuk',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Guam',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Guam',
    timeZoneShortDescription: 'UTC+10:00/ChST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Port_Moresby',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Port Moresby',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Saipan',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Saipan',
    timeZoneShortDescription: 'UTC+10:00/ChST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Truk',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Truk',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Yap',
    timeZoneOffset: 600,
    timeZoneDescription: '(UTC+10:00) Pacific/Yap',
    timeZoneShortDescription: 'UTC+10:00/+10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Adelaide',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/Adelaide',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Broken_Hill',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/Broken Hill',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Darwin',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/Darwin',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/North',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/North',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/South',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/South',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Yancowinna',
    timeZoneOffset: 570,
    timeZoneDescription: '(UTC+09:30) Australia/Yancowinna',
    timeZoneShortDescription: 'UTC+09:30/ACST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Chita',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Chita',
    timeZoneShortDescription: 'UTC+09:00/+09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Dili',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Dili',
    timeZoneShortDescription: 'UTC+09:00/+09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Jayapura',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Jayapura',
    timeZoneShortDescription: 'UTC+09:00/WIT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Khandyga',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Khandyga',
    timeZoneShortDescription: 'UTC+09:00/+09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Pyongyang',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Pyongyang',
    timeZoneShortDescription: 'UTC+09:00/KST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Seoul',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Seoul',
    timeZoneShortDescription: 'UTC+09:00/KST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tokyo',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Tokyo',
    timeZoneShortDescription: 'UTC+09:00/JST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Yakutsk',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Asia/Yakutsk',
    timeZoneShortDescription: 'UTC+09:00/+09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-9',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Etc/GMT-9',
    timeZoneShortDescription: 'UTC+09:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Japan',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Japan',
    timeZoneShortDescription: 'UTC+09:00/JST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Palau',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) Pacific/Palau',
    timeZoneShortDescription: 'UTC+09:00/+09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'ROK',
    timeZoneOffset: 540,
    timeZoneDescription: '(UTC+09:00) ROK',
    timeZoneShortDescription: 'UTC+09:00/KST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Eucla',
    timeZoneOffset: 525,
    timeZoneDescription: '(UTC+08:45) Australia/Eucla',
    timeZoneShortDescription: 'UTC+08:45/+0845',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Casey',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Antarctica/Casey',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Brunei',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Brunei',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Choibalsan',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Choibalsan',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Chongqing',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Chongqing',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Chungking',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Chungking',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Harbin',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Harbin',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Hong_Kong',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Hong Kong',
    timeZoneShortDescription: 'UTC+08:00/HKT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Irkutsk',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Irkutsk',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kuala_Lumpur',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Kuala Lumpur',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kuching',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Kuching',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Macao',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Macao',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Macau',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Macau',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Makassar',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Makassar',
    timeZoneShortDescription: 'UTC+08:00/WITA',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Manila',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Manila',
    timeZoneShortDescription: 'UTC+08:00/PST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Shanghai',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Shanghai',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Singapore',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Singapore',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Taipei',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Taipei',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ujung_Pandang',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Ujung Pandang',
    timeZoneShortDescription: 'UTC+08:00/WITA',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ulaanbaatar',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Ulaanbaatar',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ulan_Bator',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Asia/Ulan Bator',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/Perth',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Australia/Perth',
    timeZoneShortDescription: 'UTC+08:00/AWST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Australia/West',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Australia/West',
    timeZoneShortDescription: 'UTC+08:00/AWST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-8',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Etc/GMT-8',
    timeZoneShortDescription: 'UTC+08:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Hongkong',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Hongkong',
    timeZoneShortDescription: 'UTC+08:00/HKT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'PRC',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) PRC',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'ROC',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) ROC',
    timeZoneShortDescription: 'UTC+08:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Singapore',
    timeZoneOffset: 480,
    timeZoneDescription: '(UTC+08:00) Singapore',
    timeZoneShortDescription: 'UTC+08:00/+08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Davis',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Antarctica/Davis',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Bangkok',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Bangkok',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Barnaul',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Barnaul',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ho_Chi_Minh',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Ho Chi Minh',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Hovd',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Hovd',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Jakarta',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Jakarta',
    timeZoneShortDescription: 'UTC+07:00/WIB',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Krasnoyarsk',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Krasnoyarsk',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Novokuznetsk',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Novokuznetsk',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Novosibirsk',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Novosibirsk',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Phnom_Penh',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Phnom Penh',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Pontianak',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Pontianak',
    timeZoneShortDescription: 'UTC+07:00/WIB',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Saigon',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Saigon',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tomsk',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Tomsk',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Vientiane',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Asia/Vientiane',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-7',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Etc/GMT-7',
    timeZoneShortDescription: 'UTC+07:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Christmas',
    timeZoneOffset: 420,
    timeZoneDescription: '(UTC+07:00) Indian/Christmas',
    timeZoneShortDescription: 'UTC+07:00/+07',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Rangoon',
    timeZoneOffset: 390,
    timeZoneDescription: '(UTC+06:30) Asia/Rangoon',
    timeZoneShortDescription: 'UTC+06:30/+0630',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Yangon',
    timeZoneOffset: 390,
    timeZoneDescription: '(UTC+06:30) Asia/Yangon',
    timeZoneShortDescription: 'UTC+06:30/+0630',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Cocos',
    timeZoneOffset: 390,
    timeZoneDescription: '(UTC+06:30) Indian/Cocos',
    timeZoneShortDescription: 'UTC+06:30/+0630',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Bishkek',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Bishkek',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Dacca',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Dacca',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Dhaka',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Dhaka',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kashgar',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Kashgar',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Omsk',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Omsk',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Thimbu',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Thimbu',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Thimphu',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Thimphu',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Urumqi',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Asia/Urumqi',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-6',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Etc/GMT-6',
    timeZoneShortDescription: 'UTC+06:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Chagos',
    timeZoneOffset: 360,
    timeZoneDescription: '(UTC+06:00) Indian/Chagos',
    timeZoneShortDescription: 'UTC+06:00/+06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kathmandu',
    timeZoneOffset: 345,
    timeZoneDescription: '(UTC+05:45) Asia/Kathmandu',
    timeZoneShortDescription: 'UTC+05:45/+0545',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Katmandu',
    timeZoneOffset: 345,
    timeZoneDescription: '(UTC+05:45) Asia/Katmandu',
    timeZoneShortDescription: 'UTC+05:45/+0545',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Calcutta',
    timeZoneOffset: 330,
    timeZoneDescription: '(UTC+05:30) Asia/Calcutta',
    timeZoneShortDescription: 'UTC+05:30/IST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Colombo',
    timeZoneOffset: 330,
    timeZoneDescription: '(UTC+05:30) Asia/Colombo',
    timeZoneShortDescription: 'UTC+05:30/+0530',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kolkata',
    timeZoneOffset: 330,
    timeZoneDescription: '(UTC+05:30) Asia/Kolkata',
    timeZoneShortDescription: 'UTC+05:30/IST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Mawson',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Antarctica/Mawson',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Vostok',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Antarctica/Vostok',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Almaty',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Almaty',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Aqtau',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Aqtau',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Aqtobe',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Aqtobe',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ashgabat',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Ashgabat',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Ashkhabad',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Ashkhabad',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Atyrau',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Atyrau',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Dushanbe',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Dushanbe',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Karachi',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Karachi',
    timeZoneShortDescription: 'UTC+05:00/PKT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Oral',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Oral',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Qostanay',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Qostanay',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Qyzylorda',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Qyzylorda',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Samarkand',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Samarkand',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tashkent',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Tashkent',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Yekaterinburg',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Asia/Yekaterinburg',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-5',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Etc/GMT-5',
    timeZoneShortDescription: 'UTC+05:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Kerguelen',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Indian/Kerguelen',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Maldives',
    timeZoneOffset: 300,
    timeZoneDescription: '(UTC+05:00) Indian/Maldives',
    timeZoneShortDescription: 'UTC+05:00/+05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Kabul',
    timeZoneOffset: 270,
    timeZoneDescription: '(UTC+04:30) Asia/Kabul',
    timeZoneShortDescription: 'UTC+04:30/+0430',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Baku',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Asia/Baku',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Dubai',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Asia/Dubai',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Muscat',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Asia/Muscat',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tbilisi',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Asia/Tbilisi',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Yerevan',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Asia/Yerevan',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-4',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Etc/GMT-4',
    timeZoneShortDescription: 'UTC+04:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Astrakhan',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Europe/Astrakhan',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Samara',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Europe/Samara',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Saratov',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Europe/Saratov',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Ulyanovsk',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Europe/Ulyanovsk',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Mahe',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Indian/Mahe',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Mauritius',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Indian/Mauritius',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Reunion',
    timeZoneOffset: 240,
    timeZoneDescription: '(UTC+04:00) Indian/Reunion',
    timeZoneShortDescription: 'UTC+04:00/+04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tehran',
    timeZoneOffset: 210,
    timeZoneDescription: '(UTC+03:30) Asia/Tehran',
    timeZoneShortDescription: 'UTC+03:30/+0330',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Iran',
    timeZoneOffset: 210,
    timeZoneDescription: '(UTC+03:30) Iran',
    timeZoneShortDescription: 'UTC+03:30/+0330',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Addis_Ababa',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Addis Ababa',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Asmara',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Asmara',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Asmera',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Asmera',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Cairo',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Cairo',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-04-24T22:00:00Z',
    timeZoneDstEndTime: '2025-10-30T21:00:00Z',
  },
  {
    timeZoneName: 'Africa/Dar_es_Salaam',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Dar es Salaam',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Djibouti',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Djibouti',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Kampala',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Kampala',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Mogadishu',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Mogadishu',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Nairobi',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Africa/Nairobi',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Syowa',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Antarctica/Syowa',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Aden',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Aden',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Amman',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Amman',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Baghdad',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Baghdad',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Bahrain',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Bahrain',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Beirut',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Beirut',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-29T22:00:00Z',
    timeZoneDstEndTime: '2025-10-25T21:00:00Z',
  },
  {
    timeZoneName: 'Asia/Damascus',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Damascus',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Famagusta',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Famagusta',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Asia/Gaza',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Gaza',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-04-12T00:00:00Z',
    timeZoneDstEndTime: '2025-10-24T23:00:00Z',
  },
  {
    timeZoneName: 'Asia/Hebron',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Hebron',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-04-12T00:00:00Z',
    timeZoneDstEndTime: '2025-10-24T23:00:00Z',
  },
  {
    timeZoneName: 'Asia/Istanbul',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Istanbul',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Jerusalem',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Jerusalem',
    timeZoneShortDescription: 'UTC+03:00/IDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-28T00:00:00Z',
    timeZoneDstEndTime: '2025-10-25T23:00:00Z',
  },
  {
    timeZoneName: 'Asia/Kuwait',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Kuwait',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Nicosia',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Nicosia',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Asia/Qatar',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Qatar',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Riyadh',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Riyadh',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Asia/Tel_Aviv',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Asia/Tel Aviv',
    timeZoneShortDescription: 'UTC+03:00/IDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-28T00:00:00Z',
    timeZoneDstEndTime: '2025-10-25T23:00:00Z',
  },
  {
    timeZoneName: 'EET',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) EET',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Egypt',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Egypt',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-04-24T22:00:00Z',
    timeZoneDstEndTime: '2025-10-30T21:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT-3',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Etc/GMT-3',
    timeZoneShortDescription: 'UTC+03:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Athens',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Athens',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Bucharest',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Bucharest',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Chisinau',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Chisinau',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T00:00:00Z',
    timeZoneDstEndTime: '2025-10-26T00:00:00Z',
  },
  {
    timeZoneName: 'Europe/Helsinki',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Helsinki',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Istanbul',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Istanbul',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Kiev',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Kiev',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Kirov',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Kirov',
    timeZoneShortDescription: 'UTC+03:00/MSK',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Kyiv',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Kyiv',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Mariehamn',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Mariehamn',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Minsk',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Minsk',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Moscow',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Moscow',
    timeZoneShortDescription: 'UTC+03:00/MSK',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Nicosia',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Nicosia',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Riga',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Riga',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Simferopol',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Simferopol',
    timeZoneShortDescription: 'UTC+03:00/MSK',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Sofia',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Sofia',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Tallinn',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Tallinn',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Tiraspol',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Tiraspol',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T00:00:00Z',
    timeZoneDstEndTime: '2025-10-26T00:00:00Z',
  },
  {
    timeZoneName: 'Europe/Uzhgorod',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Uzhgorod',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Vilnius',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Vilnius',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Volgograd',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Volgograd',
    timeZoneShortDescription: 'UTC+03:00/MSK',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Zaporozhye',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Europe/Zaporozhye',
    timeZoneShortDescription: 'UTC+03:00/EEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Indian/Antananarivo',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Indian/Antananarivo',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Comoro',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Indian/Comoro',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Indian/Mayotte',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Indian/Mayotte',
    timeZoneShortDescription: 'UTC+03:00/EAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Israel',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Israel',
    timeZoneShortDescription: 'UTC+03:00/IDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-28T00:00:00Z',
    timeZoneDstEndTime: '2025-10-25T23:00:00Z',
  },
  {
    timeZoneName: 'Turkey',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) Turkey',
    timeZoneShortDescription: 'UTC+03:00/+03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'W-SU',
    timeZoneOffset: 180,
    timeZoneDescription: '(UTC+03:00) W-SU',
    timeZoneShortDescription: 'UTC+03:00/MSK',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Blantyre',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Blantyre',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Bujumbura',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Bujumbura',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Ceuta',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Ceuta',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Africa/Gaborone',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Gaborone',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Harare',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Harare',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Johannesburg',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Johannesburg',
    timeZoneShortDescription: 'UTC+02:00/SAST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Juba',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Juba',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Khartoum',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Khartoum',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Kigali',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Kigali',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Lubumbashi',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Lubumbashi',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Lusaka',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Lusaka',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Maputo',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Maputo',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Maseru',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Maseru',
    timeZoneShortDescription: 'UTC+02:00/SAST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Mbabane',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Mbabane',
    timeZoneShortDescription: 'UTC+02:00/SAST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Tripoli',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Tripoli',
    timeZoneShortDescription: 'UTC+02:00/EET',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Windhoek',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Africa/Windhoek',
    timeZoneShortDescription: 'UTC+02:00/CAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Troll',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Antarctica/Troll',
    timeZoneShortDescription: 'UTC+02:00/+02',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Arctic/Longyearbyen',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Arctic/Longyearbyen',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Jan_Mayen',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Atlantic/Jan Mayen',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'CET',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) CET',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT-2',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Etc/GMT-2',
    timeZoneShortDescription: 'UTC+02:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Amsterdam',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Amsterdam',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Andorra',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Andorra',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Belgrade',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Belgrade',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Berlin',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Berlin',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Bratislava',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Bratislava',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Brussels',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Brussels',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Budapest',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Budapest',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Busingen',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Busingen',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Copenhagen',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Copenhagen',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Gibraltar',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Gibraltar',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Kaliningrad',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Kaliningrad',
    timeZoneShortDescription: 'UTC+02:00/EET',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Ljubljana',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Ljubljana',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Luxembourg',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Luxembourg',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Madrid',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Madrid',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Malta',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Malta',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Monaco',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Monaco',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Oslo',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Oslo',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Paris',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Paris',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Podgorica',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Podgorica',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Prague',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Prague',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Rome',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Rome',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/San_Marino',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/San Marino',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Sarajevo',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Sarajevo',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Skopje',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Skopje',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Stockholm',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Stockholm',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Tirane',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Tirane',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Vaduz',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Vaduz',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Vatican',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Vatican',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Vienna',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Vienna',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Warsaw',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Warsaw',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Zagreb',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Zagreb',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Zurich',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Europe/Zurich',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Libya',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Libya',
    timeZoneShortDescription: 'UTC+02:00/EET',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'MET',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) MET',
    timeZoneShortDescription: 'UTC+02:00/MEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Poland',
    timeZoneOffset: 120,
    timeZoneDescription: '(UTC+02:00) Poland',
    timeZoneShortDescription: 'UTC+02:00/CEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Africa/Algiers',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Algiers',
    timeZoneShortDescription: 'UTC+01:00/CET',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Bangui',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Bangui',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Brazzaville',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Brazzaville',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Casablanca',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Casablanca',
    timeZoneShortDescription: 'UTC+01:00/+01',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Douala',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Douala',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/El_Aaiun',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/El Aaiun',
    timeZoneShortDescription: 'UTC+01:00/+01',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Kinshasa',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Kinshasa',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Lagos',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Lagos',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Libreville',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Libreville',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Luanda',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Luanda',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Malabo',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Malabo',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Ndjamena',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Ndjamena',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Niamey',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Niamey',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Porto-Novo',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Porto-Novo',
    timeZoneShortDescription: 'UTC+01:00/WAT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Tunis',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Africa/Tunis',
    timeZoneShortDescription: 'UTC+01:00/CET',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Atlantic/Canary',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Atlantic/Canary',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Faeroe',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Atlantic/Faeroe',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Faroe',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Atlantic/Faroe',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Madeira',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Atlantic/Madeira',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Eire',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Eire',
    timeZoneShortDescription: 'UTC+01:00/IST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-1',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Etc/GMT-1',
    timeZoneShortDescription: 'UTC+01:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Belfast',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Belfast',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Dublin',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Dublin',
    timeZoneShortDescription: 'UTC+01:00/IST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Europe/Guernsey',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Guernsey',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Isle_of_Man',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Isle of Man',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Jersey',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Jersey',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/Lisbon',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/Lisbon',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Europe/London',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Europe/London',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'GB',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) GB',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'GB-Eire',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) GB-Eire',
    timeZoneShortDescription: 'UTC+01:00/BST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Portugal',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) Portugal',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'WET',
    timeZoneOffset: 60,
    timeZoneDescription: '(UTC+01:00) WET',
    timeZoneShortDescription: 'UTC+01:00/WEST',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Africa/Abidjan',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Abidjan',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Accra',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Accra',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Bamako',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Bamako',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Banjul',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Banjul',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Bissau',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Bissau',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Conakry',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Conakry',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Dakar',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Dakar',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Freetown',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Freetown',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Lome',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Lome',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Monrovia',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Monrovia',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Nouakchott',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Nouakchott',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Ouagadougou',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Ouagadougou',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Sao_Tome',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Sao Tome',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Africa/Timbuktu',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Africa/Timbuktu',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Danmarkshavn',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) America/Danmarkshavn',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Atlantic/Azores',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Atlantic/Azores',
    timeZoneShortDescription: 'UTC+00:00/+00',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Reykjavik',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Atlantic/Reykjavik',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Atlantic/St_Helena',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Atlantic/St Helena',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/GMT',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/GMT+0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT-0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/GMT-0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/GMT0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/Greenwich',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/Greenwich',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/UCT',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/UCT',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/UTC',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/UTC',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/Universal',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/Universal',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/Zulu',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Etc/Zulu',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Factory',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Factory',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'GMT',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) GMT',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'GMT+0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) GMT+0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'GMT-0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) GMT-0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'GMT0',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) GMT0',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Greenwich',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Greenwich',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Iceland',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Iceland',
    timeZoneShortDescription: 'UTC+00:00/GMT',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'UCT',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) UCT',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'UTC',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) UTC',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Universal',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Universal',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Zulu',
    timeZoneOffset: 0,
    timeZoneDescription: '(UTC+00:00) Zulu',
    timeZoneShortDescription: 'UTC+00:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Godthab',
    timeZoneOffset: -60,
    timeZoneDescription: '(UTC-01:00) America/Godthab',
    timeZoneShortDescription: 'UTC-01:00/-01',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'America/Nuuk',
    timeZoneOffset: -60,
    timeZoneDescription: '(UTC-01:00) America/Nuuk',
    timeZoneShortDescription: 'UTC-01:00/-01',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'America/Scoresbysund',
    timeZoneOffset: -60,
    timeZoneDescription: '(UTC-01:00) America/Scoresbysund',
    timeZoneShortDescription: 'UTC-01:00/-01',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-30T01:00:00Z',
    timeZoneDstEndTime: '2025-10-26T01:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Cape_Verde',
    timeZoneOffset: -60,
    timeZoneDescription: '(UTC-01:00) Atlantic/Cape Verde',
    timeZoneShortDescription: 'UTC-01:00/-01',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+1',
    timeZoneOffset: -60,
    timeZoneDescription: '(UTC-01:00) Etc/GMT+1',
    timeZoneShortDescription: 'UTC-01:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Miquelon',
    timeZoneOffset: -120,
    timeZoneDescription: '(UTC-02:00) America/Miquelon',
    timeZoneShortDescription: 'UTC-02:00/-02',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T05:00:00Z',
    timeZoneDstEndTime: '2025-11-02T04:00:00Z',
  },
  {
    timeZoneName: 'America/Noronha',
    timeZoneOffset: -120,
    timeZoneDescription: '(UTC-02:00) America/Noronha',
    timeZoneShortDescription: 'UTC-02:00/-02',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Atlantic/South_Georgia',
    timeZoneOffset: -120,
    timeZoneDescription: '(UTC-02:00) Atlantic/South Georgia',
    timeZoneShortDescription: 'UTC-02:00/-02',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Brazil/DeNoronha',
    timeZoneOffset: -120,
    timeZoneDescription: '(UTC-02:00) Brazil/DeNoronha',
    timeZoneShortDescription: 'UTC-02:00/-02',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+2',
    timeZoneOffset: -120,
    timeZoneDescription: '(UTC-02:00) Etc/GMT+2',
    timeZoneShortDescription: 'UTC-02:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Johns',
    timeZoneOffset: -150,
    timeZoneDescription: '(UTC-02:30) America/St Johns',
    timeZoneShortDescription: 'UTC-02:30/NDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T05:30:00Z',
    timeZoneDstEndTime: '2025-11-02T04:30:00Z',
  },
  {
    timeZoneName: 'Canada/Newfoundland',
    timeZoneOffset: -150,
    timeZoneDescription: '(UTC-02:30) Canada/Newfoundland',
    timeZoneShortDescription: 'UTC-02:30/NDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T05:30:00Z',
    timeZoneDstEndTime: '2025-11-02T04:30:00Z',
  },
  {
    timeZoneName: 'America/Araguaina',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Araguaina',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Buenos_Aires',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Buenos Aires',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Catamarca',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Catamarca',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/ComodRivadavia',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/ComodRivadavia',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Cordoba',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Cordoba',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Jujuy',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Jujuy',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/La_Rioja',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/La Rioja',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Mendoza',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Mendoza',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Rio_Gallegos',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Rio Gallegos',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Salta',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Salta',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/San_Juan',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/San Juan',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/San_Luis',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/San Luis',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Tucuman',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Tucuman',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Argentina/Ushuaia',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Argentina/Ushuaia',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Bahia',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Bahia',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Belem',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Belem',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Buenos_Aires',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Buenos Aires',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Catamarca',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Catamarca',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Cayenne',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Cayenne',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Cordoba',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Cordoba',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Fortaleza',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Fortaleza',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Glace_Bay',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Glace Bay',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'America/Goose_Bay',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Goose Bay',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'America/Halifax',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Halifax',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'America/Jujuy',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Jujuy',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Maceio',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Maceio',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Mendoza',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Mendoza',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Moncton',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Moncton',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'America/Montevideo',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Montevideo',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Paramaribo',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Paramaribo',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Punta_Arenas',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Punta Arenas',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Recife',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Recife',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Rosario',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Rosario',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Santarem',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Santarem',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Sao_Paulo',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Sao Paulo',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Thule',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) America/Thule',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'Antarctica/Palmer',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Antarctica/Palmer',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Antarctica/Rothera',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Antarctica/Rothera',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Atlantic/Bermuda',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Atlantic/Bermuda',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'Atlantic/Stanley',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Atlantic/Stanley',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Brazil/East',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Brazil/East',
    timeZoneShortDescription: 'UTC-03:00/-03',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Canada/Atlantic',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Canada/Atlantic',
    timeZoneShortDescription: 'UTC-03:00/ADT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T06:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT+3',
    timeZoneOffset: -180,
    timeZoneDescription: '(UTC-03:00) Etc/GMT+3',
    timeZoneShortDescription: 'UTC-03:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Anguilla',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Anguilla',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Antigua',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Antigua',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Aruba',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Aruba',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Asuncion',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Asuncion',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Barbados',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Barbados',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Blanc-Sablon',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Blanc-Sablon',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Boa_Vista',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Boa Vista',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Campo_Grande',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Campo Grande',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Caracas',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Caracas',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Cuiaba',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Cuiaba',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Curacao',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Curacao',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Detroit',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Detroit',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Dominica',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Dominica',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Fort_Wayne',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Fort Wayne',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Grand_Turk',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Grand Turk',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Grenada',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Grenada',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Guadeloupe',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Guadeloupe',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Guyana',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Guyana',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Havana',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Havana',
    timeZoneShortDescription: 'UTC-04:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T05:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Indianapolis',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Indianapolis',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Marengo',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Marengo',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Petersburg',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Petersburg',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Vevay',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Vevay',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Vincennes',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Vincennes',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Winamac',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indiana/Winamac',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Indianapolis',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Indianapolis',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Iqaluit',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Iqaluit',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Kentucky/Louisville',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Kentucky/Louisville',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Kentucky/Monticello',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Kentucky/Monticello',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Kralendijk',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Kralendijk',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/La_Paz',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/La Paz',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Louisville',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Louisville',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Lower_Princes',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Lower Princes',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Manaus',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Manaus',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Marigot',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Marigot',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Martinique',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Martinique',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Montreal',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Montreal',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Montserrat',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Montserrat',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Nassau',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Nassau',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/New_York',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/New York',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Nipigon',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Nipigon',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Pangnirtung',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Pangnirtung',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Port_of_Spain',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Port of Spain',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Port-au-Prince',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Port-au-Prince',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Porto_Velho',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Porto Velho',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Puerto_Rico',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Puerto Rico',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Santiago',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Santiago',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Santo_Domingo',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Santo Domingo',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Barthelemy',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/St Barthelemy',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Kitts',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/St Kitts',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Lucia',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/St Lucia',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Thomas',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/St Thomas',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/St_Vincent',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/St Vincent',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Thunder_Bay',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Thunder Bay',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Toronto',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Toronto',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Tortola',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Tortola',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Virgin',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) America/Virgin',
    timeZoneShortDescription: 'UTC-04:00/AST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Brazil/West',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) Brazil/West',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Canada/Eastern',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) Canada/Eastern',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'Chile/Continental',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) Chile/Continental',
    timeZoneShortDescription: 'UTC-04:00/-04',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Cuba',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) Cuba',
    timeZoneShortDescription: 'UTC-04:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T05:00:00Z',
    timeZoneDstEndTime: '2025-11-02T05:00:00Z',
  },
  {
    timeZoneName: 'EST5EDT',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) EST5EDT',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT+4',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) Etc/GMT+4',
    timeZoneShortDescription: 'UTC-04:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/East-Indiana',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) US/East-Indiana',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'US/Eastern',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) US/Eastern',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'US/Michigan',
    timeZoneOffset: -240,
    timeZoneDescription: '(UTC-04:00) US/Michigan',
    timeZoneShortDescription: 'UTC-04:00/EDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T07:00:00Z',
    timeZoneDstEndTime: '2025-11-02T06:00:00Z',
  },
  {
    timeZoneName: 'America/Atikokan',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Atikokan',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Bogota',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Bogota',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Cancun',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Cancun',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Cayman',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Cayman',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Chicago',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Chicago',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Coral_Harbour',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Coral Harbour',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Eirunepe',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Eirunepe',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Guayaquil',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Guayaquil',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Indiana/Knox',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Indiana/Knox',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Indiana/Tell_City',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Indiana/Tell City',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Jamaica',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Jamaica',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Knox_IN',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Knox IN',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Lima',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Lima',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Matamoros',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Matamoros',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Menominee',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Menominee',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/North_Dakota/Beulah',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/North Dakota/Beulah',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/North_Dakota/Center',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/North Dakota/Center',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/North_Dakota/New_Salem',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/North Dakota/New Salem',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Ojinaga',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Ojinaga',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Panama',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Panama',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Porto_Acre',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Porto Acre',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Rainy_River',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Rainy River',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Rankin_Inlet',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Rankin Inlet',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Resolute',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Resolute',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Rio_Branco',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Rio Branco',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Winnipeg',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) America/Winnipeg',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'Brazil/Acre',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) Brazil/Acre',
    timeZoneShortDescription: 'UTC-05:00/-05',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'CST6CDT',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) CST6CDT',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'Canada/Central',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) Canada/Central',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'EST',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) EST',
    timeZoneShortDescription: 'UTC-05:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+5',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) Etc/GMT+5',
    timeZoneShortDescription: 'UTC-05:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Jamaica',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) Jamaica',
    timeZoneShortDescription: 'UTC-05:00/EST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Central',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) US/Central',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'US/Indiana-Starke',
    timeZoneOffset: -300,
    timeZoneDescription: '(UTC-05:00) US/Indiana-Starke',
    timeZoneShortDescription: 'UTC-05:00/CDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T08:00:00Z',
    timeZoneDstEndTime: '2025-11-02T07:00:00Z',
  },
  {
    timeZoneName: 'America/Bahia_Banderas',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Bahia Banderas',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Belize',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Belize',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Boise',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Boise',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Cambridge_Bay',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Cambridge Bay',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Chihuahua',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Chihuahua',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Ciudad_Juarez',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Ciudad Juarez',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Costa_Rica',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Costa Rica',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Denver',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Denver',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Edmonton',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Edmonton',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/El_Salvador',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/El Salvador',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Guatemala',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Guatemala',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Inuvik',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Inuvik',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Managua',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Managua',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Merida',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Merida',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Mexico_City',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Mexico City',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Monterrey',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Monterrey',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Regina',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Regina',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Shiprock',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Shiprock',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Swift_Current',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Swift Current',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Tegucigalpa',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Tegucigalpa',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Yellowknife',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) America/Yellowknife',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'Canada/Mountain',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Canada/Mountain',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'Canada/Saskatchewan',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Canada/Saskatchewan',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Chile/EasterIsland',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Chile/EasterIsland',
    timeZoneShortDescription: 'UTC-06:00/-06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+6',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Etc/GMT+6',
    timeZoneShortDescription: 'UTC-06:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'MST7MDT',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) MST7MDT',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'Mexico/General',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Mexico/General',
    timeZoneShortDescription: 'UTC-06:00/CST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Navajo',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Navajo',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'Pacific/Easter',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Pacific/Easter',
    timeZoneShortDescription: 'UTC-06:00/-06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Galapagos',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) Pacific/Galapagos',
    timeZoneShortDescription: 'UTC-06:00/-06',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Mountain',
    timeZoneOffset: -360,
    timeZoneDescription: '(UTC-06:00) US/Mountain',
    timeZoneShortDescription: 'UTC-06:00/MDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T09:00:00Z',
    timeZoneDstEndTime: '2025-11-02T08:00:00Z',
  },
  {
    timeZoneName: 'America/Creston',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Creston',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Dawson',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Dawson',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Dawson_Creek',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Dawson Creek',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Ensenada',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Ensenada',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Fort_Nelson',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Fort Nelson',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Hermosillo',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Hermosillo',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Los_Angeles',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Los Angeles',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Mazatlan',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Mazatlan',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Phoenix',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Phoenix',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'America/Santa_Isabel',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Santa Isabel',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Tijuana',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Tijuana',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Vancouver',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Vancouver',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Whitehorse',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) America/Whitehorse',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Canada/Pacific',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) Canada/Pacific',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'Canada/Yukon',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) Canada/Yukon',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+7',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) Etc/GMT+7',
    timeZoneShortDescription: 'UTC-07:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'MST',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) MST',
    timeZoneShortDescription: 'UTC-07:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Mexico/BajaNorte',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) Mexico/BajaNorte',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'Mexico/BajaSur',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) Mexico/BajaSur',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'PST8PDT',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) PST8PDT',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'US/Arizona',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) US/Arizona',
    timeZoneShortDescription: 'UTC-07:00/MST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Pacific',
    timeZoneOffset: -420,
    timeZoneDescription: '(UTC-07:00) US/Pacific',
    timeZoneShortDescription: 'UTC-07:00/PDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T10:00:00Z',
    timeZoneDstEndTime: '2025-11-02T09:00:00Z',
  },
  {
    timeZoneName: 'America/Anchorage',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Anchorage',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Juneau',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Juneau',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Metlakatla',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Metlakatla',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Nome',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Nome',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Sitka',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Sitka',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Yakutat',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) America/Yakutat',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT+8',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) Etc/GMT+8',
    timeZoneShortDescription: 'UTC-08:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Pitcairn',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) Pacific/Pitcairn',
    timeZoneShortDescription: 'UTC-08:00/-08',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Alaska',
    timeZoneOffset: -480,
    timeZoneDescription: '(UTC-08:00) US/Alaska',
    timeZoneShortDescription: 'UTC-08:00/AKDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T11:00:00Z',
    timeZoneDstEndTime: '2025-11-02T10:00:00Z',
  },
  {
    timeZoneName: 'America/Adak',
    timeZoneOffset: -540,
    timeZoneDescription: '(UTC-09:00) America/Adak',
    timeZoneShortDescription: 'UTC-09:00/HDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T12:00:00Z',
    timeZoneDstEndTime: '2025-11-02T11:00:00Z',
  },
  {
    timeZoneName: 'America/Atka',
    timeZoneOffset: -540,
    timeZoneDescription: '(UTC-09:00) America/Atka',
    timeZoneShortDescription: 'UTC-09:00/HDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T12:00:00Z',
    timeZoneDstEndTime: '2025-11-02T11:00:00Z',
  },
  {
    timeZoneName: 'Etc/GMT+9',
    timeZoneOffset: -540,
    timeZoneDescription: '(UTC-09:00) Etc/GMT+9',
    timeZoneShortDescription: 'UTC-09:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Gambier',
    timeZoneOffset: -540,
    timeZoneDescription: '(UTC-09:00) Pacific/Gambier',
    timeZoneShortDescription: 'UTC-09:00/-09',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Aleutian',
    timeZoneOffset: -540,
    timeZoneDescription: '(UTC-09:00) US/Aleutian',
    timeZoneShortDescription: 'UTC-09:00/HDT',
    timeZoneIsDst: true,
    timeZoneDstStartTime: '2025-03-09T12:00:00Z',
    timeZoneDstEndTime: '2025-11-02T11:00:00Z',
  },
  {
    timeZoneName: 'Pacific/Marquesas',
    timeZoneOffset: -570,
    timeZoneDescription: '(UTC-09:30) Pacific/Marquesas',
    timeZoneShortDescription: 'UTC-09:30/-0930',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+10',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) Etc/GMT+10',
    timeZoneShortDescription: 'UTC-10:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'HST',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) HST',
    timeZoneShortDescription: 'UTC-10:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Honolulu',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) Pacific/Honolulu',
    timeZoneShortDescription: 'UTC-10:00/HST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Johnston',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) Pacific/Johnston',
    timeZoneShortDescription: 'UTC-10:00/HST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Rarotonga',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) Pacific/Rarotonga',
    timeZoneShortDescription: 'UTC-10:00/-10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Tahiti',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) Pacific/Tahiti',
    timeZoneShortDescription: 'UTC-10:00/-10',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Hawaii',
    timeZoneOffset: -600,
    timeZoneDescription: '(UTC-10:00) US/Hawaii',
    timeZoneShortDescription: 'UTC-10:00/HST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+11',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) Etc/GMT+11',
    timeZoneShortDescription: 'UTC-11:00/UTC',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Midway',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) Pacific/Midway',
    timeZoneShortDescription: 'UTC-11:00/SST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Niue',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) Pacific/Niue',
    timeZoneShortDescription: 'UTC-11:00/-11',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Pago_Pago',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) Pacific/Pago Pago',
    timeZoneShortDescription: 'UTC-11:00/SST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Pacific/Samoa',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) Pacific/Samoa',
    timeZoneShortDescription: 'UTC-11:00/SST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'US/Samoa',
    timeZoneOffset: -660,
    timeZoneDescription: '(UTC-11:00) US/Samoa',
    timeZoneShortDescription: 'UTC-11:00/SST',
    timeZoneIsDst: false,
  },
  {
    timeZoneName: 'Etc/GMT+12',
    timeZoneOffset: -720,
    timeZoneDescription: '(UTC-12:00) Etc/GMT+12',
    timeZoneShortDescription: 'UTC-12:00/UTC',
    timeZoneIsDst: false,
  },
];
